// Anchor ids for CMS headings, FAQ blocks, and jump-menu targets. One derivation so the
// jump menu and the element it points at always agree.
export const toAnchorId = (text: string): string =>
  (text || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
